import { render, staticRenderFns } from "./pending_processing.vue?vue&type=template&id=53b886fb&"
import script from "./pending_processing.vue?vue&type=script&lang=js&"
export * from "./pending_processing.vue?vue&type=script&lang=js&"
import style0 from "./pending_processing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports